<template>
  <div>
    <transition name="fade">
      <Alert type="error" :message="error" v-if="error" />
    </transition>

    <Card has-empty-title>
      <button slot="actions" class="slds-button slds-button_brand" @click="addEmptyRow" v-if="editable">
        <svg class="slds-button__icon slds-button__icon_left" aria-hidden="true">
          <use xlink:href="../../../../../assets/symbols.svg#add"></use>
        </svg>
        {{ $t('campaignDesigner.contentSelection.addTemplate') }}
      </button>

      <!-- Rows -->
      <transition-group name="slide-fade-down">
        <template v-for="(template, index) in templates">
          <div class="row slds-m-top--medium" :key="index">
            <!-- Template ID -->
            <Input
              :label="$t('campaignDesigner.contentSelection.templateId')"
              :validation="['required']"
              :ref="`input_templateId_${index}`"
              class="slds-m-right--small"
              type="number"
              v-if="editable"
              v-model="template.templateId" />

            <OutputField
              :label="$t('campaignDesigner.contentSelection.templateId')"
              :value="template.templateId"
              v-else />

            <!-- Template name -->
            <Input
              :label="$t('campaignDesigner.contentSelection.templateName')"
              :validation="['required']"
              class="slds-m-right--small"
              :ref="`input_templateName_${index}`"
              v-if="editable"
              v-model="template.templateName" />

            <OutputField
              :label="$t('campaignDesigner.contentSelection.templateName')"
              :value="template.templateName"
              v-else />

            <!-- Template type -->
            <Picklist
              :label="$t('campaignDesigner.contentSelection.templateType.label')"
              :options="templateTypes"
              :validation="['required']"
              class="slds-m-right--small"
              labels-prefix="campaignDesigner.contentSelection.templateType"
              :ref="`input_templateType_${index}`"
              v-if="editable"
              v-model="template.templateType" />

            <OutputField
              :label="$t('campaignDesigner.contentSelection.templateType.label')"
              :value="template.templateType"
              :options="templateTypes"
              labels-prefix="campaignDesigner.contentSelection.templateType"
              type="picklist"
              v-else />

            <!-- Actions -->
            <div class="slds-m-left--medium button-container">
              <button
                class="slds-button slds-button_icon slds-button_icon-border-filled delete-button"
                :title="$t('action.delete')"
                @click="deleteTemplate(index)"
                v-if="editable">
                <svg class="slds-button__icon" aria-hidden="true">
                  <use xlink:href="../../../../../assets/symbols.svg#delete"></use>
                </svg>
              </button>
            </div>
          </div>
        </template>
      </transition-group>
    </Card>
  </div>
</template>
<script>
import _ from 'lodash'
import Alert from '../../../../slds/Alert'
import Card from '../../../../slds/Card'
import Input from '../../../../slds/Input'
import Picklist from '../../../../slds/Picklist'
import OutputField from '../../../../slds/OutputField'
export default {
  components: {
    Alert,
    Card,
    Input,
    OutputField,
    Picklist
  },
  props: {
    editable: {
      type: Boolean,
      default: false,
      required: true
    },
    value: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data () {
    return {
      error: '',
      templates: [],
      templateTypes: []
    }
  },
  created () {
    this.templateTypes = this.$store.getters['settings/settings'].ddsTemplateType
    this.mapValue(this.value)
  },
  activated () {
    this.templateTypes = this.$store.getters['settings/settings'].ddsTemplateType
  },
  methods: {
    addEmptyRow () {
      this.error = ''
      this.templates.push({
        templateId: '',
        templateName: '',
        templateType: ''
      })
    },
    deleteTemplate (index) {
      this.templates.splice(index, 1)
    },
    getSectionToSave () {
      const mapped = this.templates.map(template => {
        return {
          templateId: {
            selected: template.templateId
          },
          templateName: {
            selected: template.templateName
          },
          templateType: {
            options: this.templateTypes,
            selected: template.templateType
          }
        }
      })

      return mapped
    },
    mapValue (value) {
      this.templates = []
      const templates = value.templates.selected

      templates.forEach(template => {
        const {
          templateId,
          templateName,
          templateType
        } = template

        this.templates.push({
          templateId: templateId.selected || '',
          templateName: templateName.selected || '',
          templateType: templateType.selected || ''
        })
      })
    },
    validate () {
      this.error = ''
      let valid = true

      if (!this.templates.length) {
        valid = false
        this.error = this.$t('campaignDesigner.contentSelection.validation.email.required')
      }

      if (valid) {
        const refs = Object.values(this.$refs).flat()
        valid = refs
          .map(r => r.validate())
          .every(v => !!v)
      }

      return valid
    }
  },
  watch: {
    value (value) {
      this.mapValue(value)
    }
  }
}
</script>
<style lang="scss" scoped>
  .add-button {
    align-self: flex-end;
  }

  .row {
    display: flex;
    flex-direction: row;

    & > * {
      align-self: flex-end;
      flex-grow: 1;
    }
  }

  .button-container {
    display: flex;
    flex-direction: row;
  }

  .delete-button:not(:disabled) {
    color: #C23933;
  }
</style>
